module.exports = __webpack_public_path__ + "media/images/icons/da_assegnare_allenamento_facilitato-dc5ef0de94640f47693ee479210f4060.svg";